
import { useStore } from '@/store'
import * as THREE from 'three'
import { defineComponent, inject, onUnmounted } from 'vue'
import { computed, watch } from 'vue'
import MaterialCreateService from '@/services/Three/material-create.service'
import References from '@/singletons/references'
import insideSettings from '@/settings/inside-settings.json'
import frontSettings from '@/settings/front-settings.json'
import TextureLoadService from '@/services/Three/texture-load.service'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'ThreeRandselInside',
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const isBagLoaded = computed(() => store.getters.isBagLoaded)
    const isSceneLoaded = computed(() => store.getters.isSceneLoaded)
    const configInsideId = computed(() => store.getters.configInsideId)
    const configFrontId = computed(() => store.getters.configFrontId)
    const colorpickerInside = computed(() => store.getters.colorpickerInside)
    const materialCreateService: MaterialCreateService = new MaterialCreateService()
    let textureLoadService: TextureLoadService

    emitter.on('updateConfig', updateOption)

    // prettier-ignore
    watch(() => isSceneLoaded.value, (_) => { initTextureLoadService() } )
    // prettier-ignore
    watch(() => colorpickerInside.value, (_) => { updateColorpicker() })

    function initTextureLoadService() {
      if (!textureLoadService || textureLoadService == undefined) {
        textureLoadService = new TextureLoadService(References.instance.getSceneReferences().maxAnisotropy)
      }
    }

    // prettier-ignore
    watch(() => configInsideId.value, (_) => { updateOption() })

    function updateOption() {
      try {
        if (configInsideId.value) {
          setInside(insideSettings.futaNoUraTextures.find((x: any) => x.id == configInsideId.value))
        } else {
          setInside(insideSettings.futaNoUraTextures.find((x: any) => x.default && x.default === true))
        }
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setInside(obj: any) {
      initTextureLoadService()
      if (obj) {
        setInsideTexture(obj)
        if (References.instance.getBodyMaterial().uniforms.futaNoUraWhiteTexture.value == null) {
          textureLoadService.loadImage(insideSettings.futaNoUraFolder + '/' + insideSettings.futaNoUraWhiteTexture, (tex: THREE.Texture | null) => {
            References.instance.getBodyMaterial().uniforms.futaNoUraWhiteTexture = { value: tex }
          })
        }
        References.instance.getBodyMaterial().uniforms.futaNoUraColor.value = materialCreateService.createColor(obj.color)
      }
    }

    function setInsideTexture(obj: any) {
      let folder = insideSettings.futaNoUraFolder
      const futaShapePath = frontSettings.futaShapeTextures.find((obj) => obj.id === configFrontId.value)
      if (configFrontId.value !== null && futaShapePath && futaShapePath.futaNoUraFolder && futaShapePath.futaNoUraFolder.length > 0) {
        folder = futaShapePath.futaNoUraFolder
      }
      const imagePath = getTexturePath(obj.texture, folder)
      textureLoadService.loadImage(imagePath, (tex: THREE.Texture | null) => {
        References.instance.getFrontMaterial().uniforms.futaNoUraTexture.value = tex
      })
    }

    function getTexturePath(path, folderName: string | undefined = undefined) {
      let texturePath = path
      if (folderName !== undefined && folderName.length > 0) {
        texturePath = (folderName.substr(-1) === '/' ? folderName : folderName + '/') + path
      }
      return texturePath
    }

    function updateColorpicker() {
      References.instance.getBodyMaterial().uniforms.futaNoUraColor.value = materialCreateService.createColor(colorpickerInside.value)
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateOption)
    })

    return {
      isBagLoaded,
      isSceneLoaded,
      configInsideId,
      colorpickerInside,
      configFrontId
    }
  }
})
